













































import Vue from "vue";
import { ITag } from "@/models/tags";
import { Component, Prop } from "vue-property-decorator";

// Types
import { IFilter, IFilteringSortingTable, ISorter } from "@/models/tables";

@Component
export default class FilterSortControls extends Vue {
  @Prop({ required: true })
  public enableSorting!: boolean;

  @Prop({ required: true })
  public enableFiltering!: boolean;

  @Prop({ default: false })
  public refreshIsDisabled!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: () => [] })
  public filters!: IFilter[];

  @Prop({ default: () => [] })
  public preDefinedFilters!: IFilter[];

  @Prop({ default: () => [] })
  public activeFilters!: IFilter[];

  @Prop({ default: () => [] })
  public sorters!: ISorter[];

  @Prop({ default: () => ({}) })
  public table!: IFilteringSortingTable;

  @Prop({ default: () => [] })
  public tags!: ITag[];

  @Prop({ default: true })
  public showRelative!: boolean;

  public onSort(field: string, direction: string) {
    this.$emit("onSort", field, direction);
  }

  public onFiltersChange(filters: IFilter[]) {
    this.$emit("onFiltersChange", filters);
  }

  public get activeSort() {
    return this.table.sort;
  }
}
